<template>
  <div>
    <Poptip
      confirm
      class="iv-main-color iv-main-hover-color iv-operate-item iv-pull-left iv-pointer uit-editor-list"
      title="确认要删除吗"
      @on-ok="expandParent('delete', item)">
      <span>删除</span>
    </Poptip>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {}
  },
  created () {},
  computed: {
    ...mapGetters(['scope'])
  },
  inject: {
    expandParent: {
      default () {
        return function () {}
      }
    }
  }
}
</script>
